import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

interface OwnProps {
    title: string;
}

export class TitleSetter extends PureComponent<OwnProps> {
    render(): JSX.Element {
        const { title } = this.props;

        return (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        );
    }
}